// @eslint-disable-for-file
import { IdentitySourceConfig } from '../../models';
import { get } from 'lodash';

export interface IdentityData {
  identity?: string;
  properties?: Record<string, unknown>;
}

export class IdentitySourceManager {
  constructor(readonly identityConfig?: IdentitySourceConfig) {}

  fetchIdentityData(dataSource: object): IdentityData {
    const data: IdentityData = {
      identity: undefined,
      properties: undefined
    };

    if (!this.identityConfig) return data;

    if (this.identityConfig.identity) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const identityValue: unknown = get(dataSource, this.identityConfig.identity);

      // warn if path doesn't exist
      if (!identityValue) {
        console.warn(`Samelogic: unable to get identity value from ${this.identityConfig.identity}`);
      } else {
        // warn if identity object is invalid
        const identityType = typeof identityValue;
        if (identityType !== 'string' && identityType !== 'number') {
          console.warn(
            `Samelogic: value of identity ${
              this.identityConfig.identity
            } should be a string or a number. Got ${String(identityValue)}`
          );
        }

        data.identity = String(identityValue);
      }
    }

    if (this.identityConfig.properties) {
      const props: Record<string, unknown> = {};

      for (const prop of this.identityConfig.properties) {
        const propName = prop.name;
        const propPath = prop.variable;

        if (propPath) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          const propValue: unknown = get(dataSource, propPath);

          // warn if path doesn't exist
          if (!propValue) {
            console.warn(`Samelogic: unable to get prop ${propName}`);
          }

          // warn if identity object is invalid
          const propType = typeof propValue;
          if (propType === 'object') {
            console.warn(`Samelogic: value of prop ${propName} should not be an object`);
          }

          props[String(propName)] = propValue;
        }
      }

      data.properties = props;
    }

    return data;
  }
}
